namespace TabAurous.Inventory {
    export interface BranchInItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        HasBom: Serenity.BooleanEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        MetalId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        UnitLabour: Serenity.DecimalEditor;
        FancyCharges: AmountEditor;
        OtherCharges: AmountEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: AmountEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        Attribute: Serenity.StringEditor;
        CalcUnitId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        Hallmark: Serenity.LookupEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: BranchInBOMEditor;
        LaborDetails: BranchInLaborEditor;
    }

    export class BranchInItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.BranchInItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BranchInItemsForm.init)  {
                BranchInItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.LookupEditor;
                var w4 = CommonCategoryLookup;
                var w5 = CommonSubCategoryLookup;
                var w6 = CommonProductSizeLookup;
                var w7 = WeightEditor;
                var w8 = s.DecimalEditor;
                var w9 = AmountEditor;
                var w10 = StoneSieveLookup;
                var w11 = s.DateEditor;
                var w12 = s.ImageUploadEditor;
                var w13 = BranchInBOMEditor;
                var w14 = BranchInLaborEditor;

                Q.initFormType(BranchInItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'HasBom', w2,
                    'AttributeId', w0,
                    'ProductTypeId', w3,
                    'CategoryId', w4,
                    'SubCategoryId', w5,
                    'BrandId', w3,
                    'SuperTypeId', w3,
                    'CollectionId', w3,
                    'ProductSizeId', w6,
                    'MetalId', w3,
                    'Pieces', w1,
                    'Weight', w7,
                    'UnitRate', w8,
                    'StoneRate', w9,
                    'OtherRate', w9,
                    'UnitLabour', w8,
                    'FancyCharges', w9,
                    'OtherCharges', w9,
                    'NetAmount', w8,
                    'GrossAmount', w9,
                    'CCNetAmount', w8,
                    'CCGrossAmount', w8,
                    'Line_No', w0,
                    'HSN', w3,
                    'NetWeight', w7,
                    'DiamondPieces', w1,
                    'DiamondWeight', w7,
                    'StonePieces', w1,
                    'StoneWeight', w7,
                    'OtherPieces', w1,
                    'OtherWeight', w7,
                    'MetalAmount', w8,
                    'DiamondAmount', w8,
                    'StoneAmount', w8,
                    'OtherAmount', w8,
                    'CalcOnId', w3,
                    'UnitCost', w8,
                    'Discount', w8,
                    'WstPer', w8,
                    'WstWt', w7,
                    'Purity', w8,
                    'PureWeight', w7,
                    'Attribute', w0,
                    'CalcUnitId', w3,
                    'KaratId', w3,
                    'MetalColorId', w3,
                    'QualityId', w3,
                    'ShapeId', w3,
                    'StoneColorId', w3,
                    'StoneSizeId', w3,
                    'SieveId', w10,
                    'GroupSieveId', w10,
                    'Remarks', w0,
                    'IsDisabled', w2,
                    'ServerDate', w11,
                    'StoneCutId', w3,
                    'StonePolishId', w3,
                    'StoneSymmetryId', w3,
                    'StoneFluorescenceId', w3,
                    'StoneCuletId', w3,
                    'StoneGirdleId', w3,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w3,
                    'CertificateNo', w0,
                    'Hallmark', w3,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w11,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'ImageName', w12,
                    'BOMDetails', w13,
                    'LaborDetails', w14
                ]);
            }
        }
    }
}
